import { supabase } from './supabase.js';

/** Tipo de contenido para el hub de redes (listado vs subasta). */
export function listingSocialContentType(listing) {
  return listing?.is_auction ? 'auction' : 'listing';
}

export function canShowListingSocialKit(listing) {
  return !!listing?.id && String(listing.status || '').toLowerCase() === 'active';
}

/**
 * Redes con URL ya registrada por listing id.
 * @param {string[]} contentIds
 * @returns {Promise<Record<string, string[]>>}
 */
export async function fetchSocialNetworksByContentIds(contentIds) {
  const ids = [...new Set((contentIds || []).map(x => String(x).trim()).filter(Boolean))].slice(0, 120);
  if (!ids.length) return {};
  const { data, error } = await supabase
    .from('social_publications')
    .select('content_id, network')
    .in('content_id', ids);
  if (error) {
    console.warn('[adminListingSocial] publications:', error.message);
    return {};
  }
  const map = {};
  for (const row of data ?? []) {
    const id = row.content_id;
    if (!id) continue;
    if (!map[id]) map[id] = [];
    const net = String(row.network || '').trim();
    if (net && !map[id].includes(net)) map[id].push(net);
  }
  return map;
}
